import { render } from "./ViewLog.vue?vue&type=template&id=605049d3&scoped=true"
import script from "./ViewLog.vue?vue&type=script&lang=js"
export * from "./ViewLog.vue?vue&type=script&lang=js"

import "./ViewLog.vue?vue&type=style&index=0&id=605049d3&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605049d3"]])

export default __exports__